<div class="picker" [attr.data-mode]="mode" role="group" aria-label="Companies and products">

  <!-- 2026-06-04 search-consolidation: the picker no longer renders its own
       search input. Filtering is driven by the page-header input via the
       `externalSearchQuery` Input. Removed: the .pk-search bar that lived
       here for both `both` and `companies-only` modes. -->

  <!-- ───────────── companies-only mode ───────────── -->
  @if (mode === 'companies-only') {
    <div class="co-list">
      @if (visibleCarriers().length === 0) {
        <div class="empty-msg">No companies match your search</div>
      }
      @for (c of visibleCarriers(); track c.id; let i = $index) {
        <button #row
                type="button"
                class="co-row co-row--rail"
                [class.is-focused]="c.id === focusedCarrierId()"
                [class.has-selection]="carrierSelectionState(c.id) !== 'none'"
                [class.kb-highlight]="activeColumn() === 'left' && i === activeIndex()"
                (click)="onCarrierRowClick(c.id, row)">
          <span class="ckb"
                [class.is-on]="carrierSelectionState(c.id) === 'all'"
                [class.is-partial]="carrierSelectionState(c.id) === 'partial'"
                (click)="onToggleCarrier(c.id, $event)">
            @if (carrierSelectionState(c.id) === 'all') {
              <svg viewBox="0 0 24 24"><path d="M4 12l6 6L20 6"/></svg>
            }
          </span>
          <span class="co-name" [attr.title]="c.name" [innerHTML]="highlight(c.name)"></span>
          <span class="co-count">
            @if (carrierSelectedCount(c.id) > 0) {
              <span class="co-count-active">{{ carrierSelectedCount(c.id) }}</span><span class="co-count-divider">/</span><span class="co-count-total">{{ c.products.length }}</span>
            } @else {
              {{ c.products.length }}
            }
          </span>
          <svg class="ico co-chev" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>
        </button>

        <!-- Inline product list. Was a CDK overlay fly-out anchored to the row;
             an overlay in a scrolling rail has to track its anchor, and the
             rail's two scroll containers are invisible to CDK, so it drifted.
             Expanding in place cannot drift, and it matches every other filter
             group in the rail. Reuses the same focusedCarrier/toggle handlers
             the fly-out used, so selection behaviour is unchanged. -->
        @if (c.id === focusedCarrierId()) {
          <div class="co-products">
            <div class="co-products-hdr">
              <span class="co-products-count">{{ carrierSelectedCount(c.id) }} of {{ c.products.length }} selected</span>
              <button type="button" class="focus-action" (click)="onSelectAllVisible()">
                {{ selectAllLabel() }}
              </button>
            </div>
            @if (visibleProductsOfFocused().length === 0) {
              <div class="empty-msg">No products match your search</div>
            }
            @for (p of visibleProductsOfFocused(); track p.id) {
              <button type="button"
                      class="prod-row prod-row--inline"
                      [class.is-checked]="isProductSelected(p.id)"
                      (click)="onToggleProduct(p.id)">
                <span class="ckb" [class.is-on]="isProductSelected(p.id)">
                  @if (isProductSelected(p.id)) {
                    <svg viewBox="0 0 24 24"><path d="M4 12l6 6L20 6"/></svg>
                  }
                </span>
                <span class="prod-name">
                  <span [innerHTML]="highlight(p.name)"></span>
                  @if (p.isNew) { <span class="badge-new">NEW</span> }
                </span>
              </button>
            }
          </div>
        }
      }
    </div>
  }

  <!-- ───────────── products-only mode ───────────── -->
  @if (mode === 'products-only') {
    @if (focusedCarrier(); as fc) {
      <div class="fly-hdr">
        <span class="logo" [class]="logoClassFor(fc)">{{ fc.logoText }}</span>
        <span class="focus-name">{{ fc.name }}</span>
        <button type="button" class="focus-action" (click)="onSelectAllVisible()">
          {{ selectAllLabel() }}
        </button>
      </div>
      <div class="prod-list">
        @if (visibleProductsOfFocused().length === 0) {
          <div class="empty-msg">No products match your search</div>
        }
        @for (p of visibleProductsOfFocused(); track p.id; let i = $index) {
          <button type="button"
                  class="prod-row"
                  [class.is-checked]="isProductSelected(p.id)"
                  [class.kb-highlight]="activeColumn() === 'right' && i === activeIndex()"
                  (click)="onToggleProduct(p.id)">
            <span class="ckb" [class.is-on]="isProductSelected(p.id)">
              @if (isProductSelected(p.id)) {
                <svg viewBox="0 0 24 24"><path d="M4 12l6 6L20 6"/></svg>
              }
            </span>
            <span class="prod-name">
              <span [innerHTML]="highlight(p.name)"></span>
              @if (p.isNew) { <span class="badge-new">NEW</span> }
            </span>
          </button>
        }
      </div>
    } @else {
      <div class="empty-msg">Select a company in the rail</div>
    }
  }

  <!-- ───────────── legacy `both` mode — two-pane miller ───────────── -->
  @if (mode === 'both') {
    <div class="miller">

      <!-- Left column: companies -->
      <aside class="miller-col miller-col--left">
        <div class="miller-col-body">
          @if (visibleCarriers().length === 0) {
            <div class="empty-msg">No companies match your search</div>
          }
          @for (c of visibleCarriers(); track c.id; let i = $index) {
            <button #row
                    type="button"
                    class="co-row"
                    [class.is-focused]="c.id === focusedCarrierId()"
                    [class.kb-highlight]="activeColumn() === 'left' && i === activeIndex()"
                    (click)="onCarrierRowClick(c.id, row)">
              <span class="ckb"
                    [class.is-on]="carrierSelectionState(c.id) === 'all'"
                    [class.is-partial]="carrierSelectionState(c.id) === 'partial'"
                    (click)="onToggleCarrier(c.id, $event)">
                @if (carrierSelectionState(c.id) === 'all') {
                  <svg viewBox="0 0 24 24"><path d="M4 12l6 6L20 6"/></svg>
                }
              </span>
              <span class="logo" [class]="logoClassFor(c)">{{ c.logoText }}</span>
              <span class="co-name" [attr.title]="c.name" [innerHTML]="highlight(c.name)"></span>
              <svg class="ico co-chev" viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg>
            </button>
          }
        </div>
      </aside>

      <!-- Right column: products of focused carrier -->
      <section class="miller-col miller-col--right">
        @if (focusedCarrier(); as fc) {
          <div class="miller-focus-hdr">
            <span class="logo" [class]="logoClassFor(fc)">{{ fc.logoText }}</span>
            <span class="focus-name">{{ fc.name }}</span>
            <button type="button" class="focus-action" (click)="onSelectAllVisible()">
              {{ selectAllLabel() }}
            </button>
          </div>
          <div class="miller-col-body">
            @if (visibleProductsOfFocused().length === 0) {
              <div class="empty-msg">No products match your search</div>
            }
            @for (p of visibleProductsOfFocused(); track p.id; let i = $index) {
              <button type="button"
                      class="prod-row"
                      [class.is-checked]="isProductSelected(p.id)"
                      [class.kb-highlight]="activeColumn() === 'right' && i === activeIndex()"
                      (click)="onToggleProduct(p.id)">
                <span class="ckb" [class.is-on]="isProductSelected(p.id)">
                  @if (isProductSelected(p.id)) {
                    <svg viewBox="0 0 24 24"><path d="M4 12l6 6L20 6"/></svg>
                  }
                </span>
                <span class="prod-name">
                  <span [innerHTML]="highlight(p.name)"></span>
                  @if (p.isNew) { <span class="badge-new">NEW</span> }
                </span>
              </button>
            }
          </div>
        } @else {
          <div class="miller-col-body">
            <div class="empty-msg">Select a company on the left</div>
          </div>
        }
      </section>

    </div>
  }

</div>
